import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Ctas from '../../../Core/Ctas';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.pc-optimum-store-accordion {
    /* width: 100%; */
    justify-content: center;
    margin: 0 auto;
  }

  border-radius: 0.75rem;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? themeGet(`colors.${backgroundColor}`) : 'transparent'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    align-items: center;
    &.md-row {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    flex-direction: column;
    justify-content: space-between;
  }
`;

export const ContentWrapper = styled.div`
  margin-bottom: 1.5rem;
  h3 {
    margin-bottom: 20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    h3 {
      margin-bottom: 30px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 100%;
    h3 {
      margin-bottom: 30px;
    }
  }

  ${Wrapper}.pc-optimum-store-accordion & {
    max-width: 1100px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: auto;
    }

    h2,
    h3,
    p {
      max-width: 900px;
      width: 100%;
      margin: 0 auto;
      text-align: center;
    }

    h2 {
      margin-bottom: 2rem;
    }

    a {
      margin-top: 2rem;
    }
  }
`;

export const Content = styled.div`
  ${Wrapper}.pc-optimum-store-banner & {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  ${Wrapper}.pc-optimum-store-accordion & {
    a {
      margin: 0;
      line-height: inherit;
    }
  }
`;

export const Stores = styled.div`
  margin-right: 0;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 100%;
  }

  ul {
    li:not(:first-child) {
      margin-top: 2rem;
    }
  }

  ${Wrapper}.pc-optimum-store-accordion & {
    max-width: none;
    margin: 3rem 0 0;

    ul {
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      li {
        width: 50%;
        margin: 1rem 0;
        padding: 0 0.5rem;
        text-align: center;

        @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
          width: calc(100% / 3);
        }

        @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
          width: calc(100% / 4);
        }
      }
    }
  }
`;

export const StyledCtas = styled(Ctas)`
  gap: 2rem;
  a {
    width: 100% !important;
  }

  ${Wrapper}.pc-optimum-store-accordion & {
    margin: 0 auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    a {
      width: fit-content !important;
    }
  }
`;
